import { useDispatch, useSelector } from "react-redux";
import { StaffArrayAdd, StaffUnDeletedStatus, setStaffAllMonth } from "../../Reducer/StaffSlice";
import { useState } from "react";
import axios from "axios";
import { setOpenMainMenu } from "../../Reducer/ModalSlice";
import { IoClose } from "react-icons/io5"

function ModalDeletedStaff() {
    const StaffArray = useSelector(state => state.StaffSlice.StaffArray)

    const CityArray = useSelector(state => state.CitySlice.CityArray)

    const User = useSelector(state => state.UserSlice.User)
    const Server = useSelector(state => state.UserSlice.Server)

    const dispatch = useDispatch()

    const [ModalUnDeletedStaff, setModalUnDeletedStaff] = useState(false)
    const [ModalDeletedStaff, setModalDeletedStaff] = useState(false)
    const [StaffSaver, setStaffSaver] = useState()
    const [CancelTouch, setCancelTouch] = useState(false)

    const handleClickRecoveryStaff = async (event) => {
        if(event.type === 'touchend')
            event.preventDefault()

        var StaffOfTheMonthsArray = []
        await dispatch(StaffUnDeletedStatus(StaffSaver.id))
        await axios.put(Server + "staff/" + StaffSaver.id, {
            Deleted: 'false'
        }, {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
            })
        await axios.get(Server + 'staffofthemonths?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then((response) => {
            StaffOfTheMonthsArray = response.data
        })
        await StaffOfTheMonthsArray.map((el) => {
            if(el.idStaff === StaffSaver.id)
                {
                    axios.put(Server + "staffofthemonths/" + el.id, {
                        Hidden: false
                    }, {
                        headers: {
                            Authorization: 'Bearer ' + User.jwt,
                        },
                        })
                }
            return(el)
        })

        await axios.get(Server + "staff?_limit=-1", {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then((responseStaff) => {
            dispatch(StaffArrayAdd(responseStaff.data))
        })

        await axios.get(Server + 'staffofthemonths?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then((responseStafffAllMonth) => {
            dispatch(setStaffAllMonth(responseStafffAllMonth.data))
        })

        setStaffSaver()
        setModalUnDeletedStaff(false)
    }

    const handleClickDeleteStaff = async (event) => {
        if(event.type === 'touchend')
            event.preventDefault()

        var StaffOfTheMonthsArray = []
        await axios.delete(Server + "staff/" + StaffSaver.id, {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })

        await axios.get(Server + 'staffofthemonths?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then((response) => {
            StaffOfTheMonthsArray = response.data
        })

        await StaffOfTheMonthsArray.map((el) => {
            if(el.idStaff === StaffSaver.id)
                {
                    axios.delete(Server + "staffofthemonths/" + el.id, {
                        headers: {
                            Authorization: 'Bearer ' + User.jwt,
                        },
                    })
                }
            return(el)
        })

        await axios.get(Server + "staff?_limit=-1", {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then((responseStaff) => {
            dispatch(StaffArrayAdd(responseStaff.data))
        })

        await axios.get(Server + 'staffofthemonths?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then((responseStafffAllMonth) => {
            dispatch(setStaffAllMonth(responseStafffAllMonth.data))
        })

        setStaffSaver()
        setModalDeletedStaff(false)
    }

    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="ModalStaffManagmentMainDiv"
            >
                <div
                className="ModalInformationDiv"
                >
                    <div
                    className="ModalInformationTextDiv"
                    >
                        Удаленные сотрудники
                    </div>
                    <button
                    className="CloseModalIconDiv"
                    onClick={(() =>{
                        dispatch(setOpenMainMenu(true))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) =>{
                        event.preventDefault()
                        if(!CancelTouch)
                            dispatch(setOpenMainMenu(true))
                    })}
                    >
                        <IoClose
                        className="CloseModalIcon"
                        />
                    </button>
                </div>
                <div
                className="ModalStaffManagmentDiv"
                >
                    {StaffArray.map((el) => 
                    el.Deleted !== 'false' &&
                        <div
                        key={el.id}
                        className="OneStaffManagmentDiv"
                        >
                            <div>
                            {CityArray.filter((a) => 
                                a.id === el.idCity
                            )[0].Name + ' '}
                            {el.Post + " " + el.FIO + ' удален ' + el.Deleted } 
                            </div>
                            <div
                            className="DivFlex Gap"
                            >
                                <button
                                className="ModalDeletedStaffButton Delete"
                                onClick={(() => {
                                    setModalDeletedStaff(true)
                                    setStaffSaver(el)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        setModalDeletedStaff(true)
                                        setStaffSaver(el)
                                    }
                                })}
                                >
                                    Удалить
                                </button>               

                                <button
                                className="ModalDeletedStaffButton UnDelete"
                                onClick={(() =>{
                                    setModalUnDeletedStaff(true)
                                    setStaffSaver(el)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        setModalUnDeletedStaff(true)
                                        setStaffSaver(el)
                                    }
                                })}
                                >
                                    Восстановить
                                </button>            
                            </div>
                        </div>
                    )}
                </div>

                    {ModalUnDeletedStaff &&
                    <div
                    className="ModalChangeHiddenGlobalDiv"
                    >

                        <div
                        className="ModalChangeHiddenMainDiv"
                        >
                            <div>
                            {'Сотрудник ' + StaffSaver.FIO + ' будет восстановлен' }
                            </div>
                            <div
                            className="ModalChangeHiddenButtonsDiv"
                            >
                                <button
                                className="ModalChangeHiddenButton Cancle"
                                onClick={(() => {
                                    setStaffSaver()
                                    setModalUnDeletedStaff(false)
                                    setOpenMainMenu(true)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        setStaffSaver()
                                        setModalUnDeletedStaff(false)
                                    }
                                })}
                                >
                                    Отмена
                                </button>
                                <button
                                className="ModalChangeHiddenButton Ok"
                                onClick={handleClickRecoveryStaff}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                        handleClickRecoveryStaff(event)
                                }}
                                >
                                    Ок
                                </button>
                            </div>
                        </div>
                    </div>
                    }

                    {ModalDeletedStaff &&
                    <div
                    className="ModalChangeHiddenGlobalDiv"
                    >

                        <div
                        className="ModalChangeHiddenMainDiv"
                        >
                            <div>
                            {'Сотрудник ' + StaffSaver.FIO + ' и данные о нем будут полностью удалены без возможности восстановления' }
                            </div>
                            <div
                            className="ModalChangeHiddenButtonsDiv"
                            >
                                <button
                                className="ModalChangeHiddenButton Cancle"
                                onClick={(() => {
                                    setStaffSaver()
                                    setModalDeletedStaff(false)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        setStaffSaver()
                                        setModalDeletedStaff(false)
                                    }
                                })}
                                >
                                    Отмена
                                </button>
                                <button
                                className="ModalChangeHiddenButton Ok"
                                onClick={handleClickDeleteStaff}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                        handleClickDeleteStaff(event)
                                }}
                                >
                                    Ок
                                </button>
                            </div>
                        </div>
                    </div>
                    }
            </div>
        </div>
    )
}

export default ModalDeletedStaff;
